import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AcademicianStartupButton } from "@/components/academician/academicianstartup-button";
import { SaveIcon } from "lucide-react";

export interface StartupProfile {
  name: string;
  oneLiner: string;
}

export interface StartupProfileTabProps {
  profile?: StartupProfile;
  onSave?: (profile: StartupProfile) => void;
  isOwner?: boolean;
  className?: string;
}

export function StartupProfileTab({
  profile,
  onSave,
  isOwner = true,
  className,
}: StartupProfileTabProps) {
  const [formData, setFormData] = useState<StartupProfile>(
    profile || {
      name: "",
      oneLiner: "",
    }
  );

  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await onSave?.(formData);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className={className}>
      <div className="max-w-3xl space-y-6">
        {/* Startup Name */}
        <div className="space-y-2">
          <Label htmlFor="startup-name">Startup Name</Label>
          <Input
            id="startup-name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            placeholder="Enter your startup name"
            className="text-lg font-semibold"
          />
        </div>

        {/* One-liner */}
        <div className="space-y-2">
          <Label htmlFor="one-liner">One-liner Description</Label>
          <Input
            id="one-liner"
            value={formData.oneLiner}
            onChange={(e) =>
              setFormData({ ...formData, oneLiner: e.target.value })
            }
            placeholder="Describe your startup in one sentence"
          />

          <p className="text-xs text-muted-foreground">
            A concise description of what your startup does
          </p>
        </div>

        {/* Save Button */}
        <div className="flex justify-end pt-4">
          <AcademicianStartupButton
            variant="primary"
            leftIcon={<SaveIcon />}
            onClick={handleSave}
            loading={isSaving}
          >
            Save Changes
          </AcademicianStartupButton>
        </div>
      </div>
    </div>
  );
}
